import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { FC } from 'react';

import DropdownContent from './DropdownContent';
import Wrapper, { DropdownArrow, DropdownContainer, Input } from './Wrapper';
import { useDatePickerHandlers } from './hooks';
import { DatePickerContainerProps } from './types';

export { ActionItem, ActionListWrapper, DatesWrapper, CalendarButton } from './Wrapper';

export const ACTION_LIST = [
  'Last 24 hours',
  'Last 3 days',
  'Last 7 days',
  'Last 30 days',
  'This month',
  'Last month',
  'Lifetime'
];

export const LAST_24_HOURS = ACTION_LIST[0];
export const LAST_3_DAYS = ACTION_LIST[1];
export const LAST_7_DAYS = ACTION_LIST[2];
export const LAST_30_DAYS = ACTION_LIST[3];
export const THIS_MONTH = ACTION_LIST[4];
export const LAST_MONTH = ACTION_LIST[5];
export const LIFETIME = ACTION_LIST[6];

const DatePickerContainer: FC<DatePickerContainerProps> = ({
  disableDates,
  isOneCalendar,
  isRangeDate = true,
  contentDirection = 'to-bottom',
  ...props
}) => {
  const [
    dates,
    inputLabel,
    wrapperRef,
    isPickerOpen,
    isActionsOpen,
    setDates,
    openActions,
    handleDatePick,
    handleApplyDates,
    handleOpenPicker,
    handleClickCancel,
    actionClickHandler,
    handleCloseDropdown
  ] = useDatePickerHandlers({ isRangeDate, ...props });

  return (
    <Wrapper ref={wrapperRef}>
      <DropdownContainer
        openDelay={250}
        closeDelay={250}
        canToggle={false}
        openByAction="click"
        openerVariant="no-icon"
        direction={contentDirection}
        onOpen={props.isPreFilledList ? openActions : handleOpenPicker}
        onClose={handleCloseDropdown}
        renderContent={
          isActionsOpen || isPickerOpen
            ? () => (
                <DropdownContent
                  selectedDates={dates}
                  onSetDates={setDates}
                  onDatePick={handleDatePick}
                  onOpenPicker={handleOpenPicker}
                  onDateApply={handleApplyDates}
                  onClickCancel={handleClickCancel}
                  onActionClick={actionClickHandler}
                  lifetimeStartTime={props.lifetimeStartTime}
                  {...{
                    isRangeDate,
                    disableDates,
                    isPickerOpen,
                    isActionsOpen,
                    isOneCalendar
                  }}
                />
              )
            : undefined
        }
      >
        <DropdownArrow
          alt="dropdown arrow"
          src="images/picker_down_arrow.svg"
          active={!isMobileOrIPad() && (isPickerOpen || isActionsOpen) ? 1 : 0}
        />
        <Input type="text" readOnly value={inputLabel} />
      </DropdownContainer>
    </Wrapper>
  );
};

export default DatePickerContainer;
